import { ContentLayout, HeaderBreadcrumbs } from "../../../shared";
import React from "react";
import { useLocation, useParams } from "react-router-dom";
import { AccountUploadHistory, ManageAccountFileUpload } from "../components";

export const UploadList = () => {
  const { id } = useParams();
  const location = useLocation();

  const isStoreAdmin = location.pathname.includes("/store-admin");
  const isUpdatePage = Boolean(id);

  const tabs = React.useMemo(
    () => [
      {
        label: "Detail",
        value: "1",
        panel: <ManageAccountFileUpload />,
      },
      {
        label: "History",
        value: "2",
        panel: <AccountUploadHistory />,
      },
    ],
    []
  );

  return (
    <ContentLayout
      title={"Account File Upload"}
      breadcrumbs={
        <HeaderBreadcrumbs
          links={[
            { name: "Dashboard", href: "/" },
            {
              name: "Account Uploads",
              href: isStoreAdmin ? "/store-admin/list" : "/list",
            },
            { name: id ? "Edit" : "Create" },
          ]}
        />
      }
      tabProps={
        isStoreAdmin || !isUpdatePage
          ? undefined
          : {
              label: "uploadHistory",
              list: tabs,
            }
      }
    >
      {(isStoreAdmin || !isUpdatePage) && <ManageAccountFileUpload />}
    </ContentLayout>
  );
};
